import { defineStore } from 'pinia';
import api from '../services/api';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
    loading: false,
    error: null,
    showLoginModal: false,
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
    isAdmin: (state) => state.user?.role === 'admin',
  },

  actions: {
    async login(credentials) {
      this.loading = true;
      this.error = null;
      try {
        // En mode dev sans serveur PHP réel tournant sur le même port,
        // on peut soit utiliser le mock, soit pointer vers le PHP.
        // Si on veut tester le PHP, il faut que l'URL soit correcte (ex: http://localhost/backend/auth/login.php)
        const response = await api.post('/auth/login.php', credentials);
        this.setAuth(response.data);
        return true;
      } catch (err) {
        this.error = err.response?.data?.error || 'Erreur de connexion';
        return false;
      } finally {
        this.loading = false;
      }
    },

    async register(userData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.post('/auth/register.php', userData);
        this.setAuth(response.data);
        return true;
      } catch (err) {
        this.error = err.response?.data?.error || 'Erreur lors de la création du compte';
        return false;
      } finally {
        this.loading = false;
      }
    },

    setAuth(data) {
      this.user = data.user;
      this.token = data.token;
      localStorage.setItem('user', JSON.stringify(data.user));
      localStorage.setItem('token', data.token);
      // Update api headers
      api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    },

    logout() {
      this.user = null;
      this.token = null;
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      delete api.defaults.headers.common['Authorization'];
    },

    // Check storage for token and setup headers on app start
    init() {
      if (this.token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;
      }
    }
  },
});
